export default {"src":"/newStatic/_next/static/media/down_arrow.d884b871.svg","height":12,"width":20};